import { useState } from "react";
import { Segmented, Sheet, Skeleton, Tabs } from "../components/ui";
import { useAccount, useOwner } from "../state/account";
import { closeSheet, sheet as sheetStore, useSheet } from "../state/sheets";
import { Deposit } from "../views/bankroll/Deposit";
import { Withdraw } from "../views/bankroll/Withdraw";
import { ClaimPanel } from "../views/house/ClaimPanel";
import { StakePanel } from "../views/house/StakePanel";
import { dollars, papers, useMe } from "../views/house/model";
import "../views/bankroll/portfolio.css";
import "../views/house/staking.css";

function Waiting({ words }: { words: string }) {
  return (
    <div className="stack-lg" aria-busy>
      <Skeleton height={48} />
      <Skeleton height={48} />
      <p className="pf-fine">{words}</p>
    </div>
  );
}

/** Money in and out of the bankroll, from any screen. */
function Funds({ tab }: { tab: "deposit" | "withdraw" }) {
  const owner = useOwner();
  const account = useAccount();
  let body;
  if (!owner) body = <Waiting words="Connect a wallet first" />;
  else if (tab === "deposit") body = <Deposit key={owner} owner={owner} />;
  else if (!account) body = <Waiting words="Loading your bankroll" />;
  else body = <Withdraw key={owner} account={account} />;
  return (
    <div className="stack-lg">
      <Tabs<"deposit" | "withdraw">
        label="Deposit or withdraw"
        value={tab}
        onChange={(next) => sheetStore.set({ kind: "funds", tab: next })}
        tabs={[
          { value: "deposit", label: "Deposit" },
          { value: "withdraw", label: "Withdraw" },
        ]}
      />
      {body}
    </div>
  );
}

/** What busts minted, staked for a cut of the house, and the cut itself. */
function Paper() {
  const me = useMe();
  const [mode, setMode] = useState<"cut" | "stake">("cut");
  const ready = me.state === "ready" ? me : null;
  return (
    <div className="stack-lg paper">
      <p className="paper-lead">Every dollar you lose mints PAPER. Staked, it earns a cut of what the house makes, paid in USDC.</p>
      <dl className="paper-figs">
        <div>
          <dt className="label">Staked</dt>
          <dd className="num">{ready ? papers(ready.staked, 10) : <Skeleton width={72} height={20} />}</dd>
        </div>
        <div>
          <dt className="label">Not staked</dt>
          <dd className="num">{ready ? papers(ready.balance, 10) : <Skeleton width={72} height={20} />}</dd>
        </div>
        <div>
          <dt className="label">Your cut</dt>
          <dd className={`num ${ready && ready.claimable !== null && ready.claimable > 0n ? "up" : ""}`}>
            {ready && ready.claimable !== null ? dollars(ready.claimable) : "—"}
          </dd>
        </div>
      </dl>
      <Segmented<"cut" | "stake">
        label="Claim or stake"
        value={mode}
        onChange={setMode}
        options={[
          { value: "cut", label: "Claim your cut" },
          { value: "stake", label: "Stake PAPER" },
        ]}
      />
      <div className="stk-in-sheet">{mode === "cut" ? <ClaimPanel me={me} /> : <StakePanel me={me} />}</div>
    </div>
  );
}

export function Sheets() {
  const open = useSheet();
  return (
    <>
      <Sheet open={open?.kind === "funds"} onClose={closeSheet} title="Bankroll">
        {open?.kind === "funds" && <Funds tab={open.tab} />}
      </Sheet>
      <Sheet open={open?.kind === "paper"} onClose={closeSheet} title="Your PAPER">
        {open?.kind === "paper" && <Paper />}
      </Sheet>
    </>
  );
}
